// @ts-nocheck
// JS for Journey Botanicals: syncs background with active accordion or carousel
(function() {
  var root = document.querySelector('.journey-botanicals');
  if (!root) return;

  // Accordion (desktop)
  var accordionItems = root.querySelectorAll('.journey-botanicals__accordion-item');

  function setActiveBackground(index) {
    var backgrounds = root.querySelectorAll('.journey-botanicals__background');
    backgrounds.forEach(function(bg, i) {
      if (i == index) {
        bg.classList.add('journey-botanicals__background--active');
      } else {
        bg.classList.remove('journey-botanicals__background--active');
      }
    });
  }

  accordionItems.forEach(function(item, idx) {
    var trigger = item.querySelector('.journey-botanicals__accordion-trigger');
    if (trigger) {
      trigger.addEventListener('click', function() {
        // Remove all transitionend listeners and force reflow before animating
        accordionItems.forEach(function(it) {
          it.classList.remove('journey-botanicals__accordion-item--active');
          var triggerEl = it.querySelector('.journey-botanicals__accordion-trigger');
          if (triggerEl) triggerEl.setAttribute('aria-expanded', 'false');
          var content = it.querySelector('.journey-botanicals__accordion-content');
          if (content && content instanceof HTMLElement) {
            // Remove all transitionend listeners by cloning
            var newContent = content.cloneNode(true);
            if (content.parentNode) {
              content.parentNode.replaceChild(newContent, content);
              content = newContent instanceof HTMLElement ? newContent : content;
            }
            // Only animate if open
            if (content instanceof HTMLElement && content.style.maxHeight && content.style.maxHeight !== '0px') {
              content.style.maxHeight = getComputedStyle(content).maxHeight;
              // Force reflow
              void content.offsetHeight;
              content.style.maxHeight = '0px';
              // Listen for transition end to hide
              var onTransitionEnd = function(e) {
                if (e.propertyName === 'max-height') {
                  content.setAttribute('hidden', '');
                  content.style.opacity = '0';
                  content.removeEventListener('transitionend', onTransitionEnd);
                }
              };
              content.addEventListener('transitionend', onTransitionEnd);
            } else if (content instanceof HTMLElement) {
              content.setAttribute('hidden', '');
              content.style.opacity = '0';
              content.style.maxHeight = '0px';
            }
          }
        });
        // Add active to clicked
        item.classList.add('journey-botanicals__accordion-item--active');
        if (trigger) trigger.setAttribute('aria-expanded', 'true');
        var content = item.querySelector('.journey-botanicals__accordion-content');
        if (content && content instanceof HTMLElement) {
          content.removeAttribute('hidden');
          // Animate open
          content.style.maxHeight = content.scrollHeight + 'px';
          content.style.opacity = '1';
        }
        setActiveBackground(idx);
      });
    }
  });

  // Expand the first item on load
  var firstItem = accordionItems[0];
  if (firstItem) {
    firstItem.classList.add('journey-botanicals__accordion-item--active');
    var firstTrigger = firstItem.querySelector('.journey-botanicals__accordion-trigger');
    if (firstTrigger) firstTrigger.setAttribute('aria-expanded', 'true');
    var firstContent = firstItem.querySelector('.journey-botanicals__accordion-content');
    if (firstContent && firstContent instanceof HTMLElement) {
      firstContent.removeAttribute('hidden');
      firstContent.style.maxHeight = firstContent.scrollHeight + 'px';
      firstContent.style.opacity = '1';
    }
    setActiveBackground(0);
  }

  // Carousel (mobile)
  var carouselTrack = root.querySelector('.journey-botanicals__carousel-track');
  var carouselSlides = root.querySelectorAll('.journey-botanicals__carousel-slide');
  var prevBtn = root.querySelector('.journey-botanicals__carousel-btn--prev');
  var nextBtn = root.querySelector('.journey-botanicals__carousel-btn--next');
  var currentIndex = 0;

  function updateCarousel(index) {
    if (carouselTrack && carouselSlides.length > 0) {
      // Move the track to show the current slide
      var translateX = -index * 100;
      carouselTrack.style.transform = 'translateX(' + translateX + '%)';
      
      // Update background
      if(window.journeyBotanicalsSetActiveBackground) {
        window.journeyBotanicalsSetActiveBackground(index);
      } else {
        setActiveBackground(index);
      }

      // Update button states
      prevBtn = root.querySelector('.journey-botanicals__carousel-btn--prev');
      nextBtn = root.querySelector('.journey-botanicals__carousel-btn--next');
      if (prevBtn && nextBtn) {
        prevBtn.disabled = index === 0;
        nextBtn.disabled = index === carouselSlides.length - 1;
      }
    }
  }

  if (carouselSlides.length > 0) {
    updateCarousel(0);
  }

  if (prevBtn && nextBtn && carouselSlides.length > 1) {
    prevBtn.addEventListener('click', function() {
      if (currentIndex > 0) {
        currentIndex = currentIndex - 1;
        updateCarousel(currentIndex);
      }
    });
    
    nextBtn.addEventListener('click', function() {
      if (currentIndex < carouselSlides.length - 1) {
        currentIndex = currentIndex + 1;
        updateCarousel(currentIndex);
      }
    });
  }

  // Make updateCarousel available globally
  window.journeyBotanicalsUpdateCarousel = updateCarousel;
  window.journeyBotanicalsSetActiveBackground = setActiveBackground;
})();
